import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import MobilePage from "../../utils/mobile-page";

import { CloseIconSlim } from "../../mobile-templates/general";
import VisibleOnHash from "../../utils/hash-popup";
import { FormRow, HorizontalInputs, Input, InputLabel, SmallInput } from "../../desktop-components/user/login-popup";
import User from "../../../../services/user";
import Config from "../../config";
import { TelegramButton } from "../../../../services/telegram/openidLogin";
import { t } from "@lingui/macro";
import PageDataFeed from "../../../../services/page-data-feed";

export default class PopupRecovery extends Component {
    state = {
        error: false,
        errorMessage: ""
    };

    render() {
        return (
            <VisibleOnHash id="recovery-page" class={"fixed z-10 inset-0 overflow-y-auto text-white backdrop-blur-sm"} hash="#recovery">
                <div class="absolute top-0 right-0 w-12 p-3 fn-close" onClick={e => MobilePage.goBack()}>
                    <CloseIconSlim />
                </div>
                <div class="pl-12 h-full">
                    <div class="flex h-full flex-col bg-blue-whale-800 text-white">
                        <RecoveryForm />

                        {!!Config.telegramLogin && <>
                            <div class="relative flex justify-center px-4 pt-8 pb-2 text-center">
                                <div class="absolute bottom-4 left-4 right-4 border-b"></div>
                                <div class="z-0 bg-blue-whale-800 px-4 text-sm"><Trans>Oppure</Trans></div>
                            </div>
                            <div class="px-4">
                                <TelegramButton
                                    class="w-full"
                                    clientId={Config.telegramLogin}
                                    text={t`Recover via Telegram`}
                                    shape="square"
                                    iconOnly={false}
                                    onSuccess={e => {
                                        MobilePage.closeHashPopup();
                                        PageDataFeed.rerender();
                                    }}
                                />
                            </div>
                        </>}

                        <div class="grow"></div>
                        <div class="bg-blue-whale-700 px-2 py-2">
                            <div class="py-1 text-center">
                                <Trans>Create an account</Trans>
                                <a class="border-b border-kobaaccent-500 pb-0.5 px-0.5 text-kobaaccent-500" href="#register">
                                    <Trans>Register</Trans>
                                </a>
                            </div>
                            <div class="py-1 text-center text-sm"><Trans>Login to place bets</Trans></div>
                        </div>
                    </div>
                </div>
            </VisibleOnHash>
        );
    }
}



export class RecoveryForm extends Component {
    state = {
        step: 1,
        otpcode: null,
        error: null,
        sending: false
    }

    errors = {
        "unknown-error": msg`Unknown internal error, please contact the support`,
        "internal-error": msg`Unknown internal error, please contact the support`,
        "already-sent": msg`The SMS has been already sent, please wait 5 minutes if you want to send a new one`,
        "not-found": msg`User account not found`,
        "invalid-phone": msg`You have submitted an invalid phone number`,
        "sms-error": msg`Unable to send the verification SMS, please try again later`,
        "invalid-otp": msg`Invalid OTP code`,
        "repeated-invalid-otp": msg`OTP code failed too much time, please send a new recovery SMS`,
        "non-matching": msg`The two passwords must be the same`
    }

    componentWillMount() {
        this.optionallyPrefillForm();
    }

    optionallyPrefillForm() {
        const urlParams = new URLSearchParams(window.location.search);
        const username = urlParams.get('user');
        if (username) {
            this.state.username = username;
            this.setState({ username });
        }
    }

    stepOneSubmit(e) {
        e.preventDefault();
        const formData = new FormData(this.form);
        User.passwordRecoverySendSms(formData.get('username').trim())
            .then(body => {
                console.info('then', body);
                if (!!body.status && body.status === 'done') {
                    this.state.error = null;
                    this.state.step = 2;
                } else {
                    this.state.error = body.status || 'unknown-error';
                }
                this.setState({});
            })
            .catch(e => {
                this.state.error = e || 'unknown-error';
                if (e === 'already-sent') {
                    this.state.step = 2;
                }
                this.setState({});
            });
    }

    stepTwoSubmit(e) {
        e.preventDefault();
        const formData = new FormData(this.form);
        const otpCode = formData.get('otp');

        User.passwordRecoveryVerifyOTP(otpCode)
            .then(body => {
                if (!!body.status && body.status === 'valid') {
                    this.state.error = null;
                    this.state.step = 3;
                    this.state.otpcode = otpCode;
                } else {
                    this.state.error = body.status || 'unknown-error';

                    if (!!body.data && body.data['attempts-left'] <= 0) {
                        this.state.error = 'repeated-invalid-otp';
                        this.state.step = 1;
                    }
                }

                this.setState({});
            })
            .catch(e => {
                this.state.error = e.error || 'unknown-error';
                this.setState({});
            });
    }

    stepThreeSubmit(e) {
        e.preventDefault();
        const formData = new FormData(this.form);
        const password = formData.get('password')
        const confirmPassword = formData.get('confirmPassword')

        if (password !== confirmPassword) {
            this.state.error = 'non-matching';
            this.setState(this.state);
            return;
        }

        User.passwordRecoveryAlterPassword(this.state.otpcode, password, confirmPassword)
            .then(body => {
                if (!!body.status && body.status === 'done') {
                    this.state.error = null;
                    this.state.step = 4;
                } else {
                    this.state.error = body.status || 'unknown-error';

                    if (!!body.data && body.data['attempts-left'] <= 0) {
                        this.state.error = 'repeated-invalid-otp';
                        this.state.step = 1;
                    }
                }

                this.setState({});
            })
            .catch(e => {
                this.state.error = e.error || 'unknown-error';
                this.setState({});
            });
    }

    stepOneForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepOneSubmit(e)}>
            <FormRow>
                <InputLabel>Phone Number</InputLabel>
                <HorizontalInputs>
                    <SmallInput value="ET +251" disabled={true} autocomplete="tel-country-code" class="w-20 bg-slate-200 text-slate-500 border-slate-300" />
                    <Input class="grow" name="username" required={true} autocomplete="tel-national" onInput={e => this.setState({ username: e.target.value })} value={this.state.username || ''} />
                </HorizontalInputs>
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-kobaaccent-400 text-kobaaccent-950 py-2 text-center text-base font-bold uppercase hover:bg-kobaaccent-600">
                    {this.state.username ? <Trans>Reset Password</Trans> : <Trans>Send SMS OTP</Trans>}
                </button>
            </div>
        </form>;
    }

    stepTwoForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepTwoSubmit(e)}>
            {this.state.username && <div class="text-sm text-slate-100 py-2"><Trans>We have sent you an SMS with a security code. Please enter it below to reset your password.</Trans></div>}

            <FormRow>
                <InputLabel>OTP Code</InputLabel>
                <HorizontalInputs>
                    <Input class="grow" name="otp" required={true} />
                </HorizontalInputs>
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-kobaaccent-400 text-kobaaccent-950 py-2 text-center text-base font-bold uppercase hover:bg-kobaaccent-600">
                    <Trans>Check OTP</Trans>
                </button>
            </div>
        </form>;
    }

    stepThreeForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepThreeSubmit(e)}>
            <FormRow>
                <InputLabel>Password</InputLabel>
                <Input placeholder={window.Translation(msg`Password`)} class="grow" type="password" name="password" required={true} autocomplete="new-password" />
            </FormRow>
            <FormRow>
                <InputLabel>Repeat Password</InputLabel>
                <Input placeholder={window.Translation(msg`Repeat Password`)} class="grow" type="password" name="confirmPassword" required={true} autocomplete="new-password" />
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-kobaaccent-400 text-kobaaccent-950 py-2 text-center text-base font-bold uppercase hover:bg-kobaaccent-600">
                    <Trans>Update Password</Trans>
                </button>
            </div>
        </form>;
    }

    stepFourForm() {
        return <div>
            <div class="w-full px-2 text-center pt-3 mb-2">
                <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-green-600 w-full">
                    <div class="-top-1/3 absolute bg-green-600 border border-green-800 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                    <span><Trans>Password updated with success!</Trans></span>
                </div>
            </div>
        </div>;
    }

    render({ onFinish }) {
        return <div class="flex flex-col gap-2">
            <div class="text-base uppercase w-full text-center py-2"><Trans>Password Recovery</Trans></div>
            <div class="w-full px-4 text-center">
                {!this.state.sending
                    ? !!this.state.error && <div class="w-full px-2 text-center pt-3 mb-2">
                        <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
                            <div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                            <span>{window.Translation(this.errors[this.state.error])}</span>
                        </div>
                    </div>
                    : <div class="w-full px-2 text-center pt-3 mb-2">
                        <i class="fa text-2xl fa-spin fa-spinner" />
                    </div>}

                {this.state.step === 1 && this.stepOneForm()}
                {this.state.step === 2 && this.stepTwoForm()}
                {this.state.step === 3 && this.stepThreeForm()}
                {this.state.step === 4 && this.stepFourForm()}
            </div>
        </div>
    }
}